import React, { useState } from 'react';
import MonthRail from '@/components/season-template/MonthRail';
import SeasonCropCard from '@/components/season-template/SeasonCropCard';
import { TodayHarvestBackdrop } from '@/components/LivingSky';

// Public visual PREVIEW of the Seasonal Planting Template building blocks
// (Month Selector rail + two crop cards on the Today-style harvest backdrop).
// No auth / network — sample data only.
export default function SeasonTemplatePreview() {
  const [month, setMonth] = useState(10);
  const [cards, setCards] = useState([
    {
      crop_id: 'crop_tomato', name: 'Tomato', category: 'Fruiting Vegetables',
      difficulty: 'intermediate', actions: ['transplant'], marginal: false, warning: null, status: 'planted',
    },
    {
      crop_id: 'crop_pumpkin', name: 'Pumpkin', category: 'Cucurbits',
      difficulty: 'advanced', actions: ['sow_direct'], marginal: true, warning: 'frost', status: 'planned',
    },
  ]);
  const cycle = (id, next) => setCards((prev) => prev.map((c) => (c.crop_id === id ? { ...c, status: next } : c)));

  return (
    <div className="min-h-screen py-10 px-4">
      <TodayHarvestBackdrop />
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold text-[#1A4331]" style={{ fontFamily: 'Outfit, sans-serif' }}>What Can I Grow?</h1>
        <p className="text-sm text-[#5C665C] mt-1 mb-6">Preview · Month selector + crop cards</p>
        <div className="hg-glass rounded-2xl p-3 mb-6">
          <MonthRail value={month} onChange={setMonth} />
        </div>
        <div className="space-y-3">
          {cards.map((c) => <SeasonCropCard key={c.crop_id} crop={c} onCycle={(n) => cycle(c.crop_id, n)} />)}
        </div>
        <p className="text-xs text-[#1A4331] mt-4 font-medium">
          Tap a card’s checkbox to cycle: unmarked → Planned (amber) → Planted (green). Marginal crops dim with a frost or heat icon.
        </p>
      </div>
    </div>
  );
}
